<template>
	<div id="app" class="site-container" :class="{ 'with-account-bar': userLogedIn }">
		<loading-bar></loading-bar>
		<header-component></header-component>
		<account-bar></account-bar>

		<router-view/>
		<footer-component></footer-component>
      <AuthModal/>

      <cookie-bar v-if="cookie"></cookie-bar>
	</div>
</template>

<script>

	import Vuex from 'vuex';
	import LoadingBar from './components/LoadingBar';
	import Header from './components/layout/Header';
	import Footer from './components/layout/Footer';
	import AccountBar from './components/parts/AccountBar';
   import AuthModal from "@/components/auth/AuthModal";


   export default {
		name: 'App',
		components: {
			LoadingBar,
			AccountBar,
			'header-component': Header,
			'footer-component': Footer,
			'cookie-bar': () => import('@/components/layout/CookieBar'),
         AuthModal
		},
		computed:{
			...Vuex.mapGetters({
				userLogedIn: 'getUserStatus',
				cookie: 'cookieBar'
			}),
		},
		mounted(){
			var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
			link.type = 'image/x-icon';
			link.rel = 'shortcut icon';
			link.href = require('@/assets/icon.png');
			document.getElementsByTagName('head')[0].appendChild(link);
		}
	}
</script>

<style lang="scss">
	@import "scss/style";

	.img-holder {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 60px;
	}

	.v-logo {
		max-width: 200px;
		margin-bottom: 35px;
	}
</style>
